export default {
  name: 'padding',
  type: 'layout',
  active: true,
  data: {
    top: '',
    bottom: '',
    left: '',
    right: ''
  }
}
